module.exports = __webpack_public_path__ + "img/question3.fe4ed9aa.png";